/*!
 * Victor Sunwear — preenchimento de endereço via CEP (ViaCEP)
 * Funciona em qualquer formulário com name="address[zip]" ou [data-victor-cep]
 */
(function () {
  'use strict';

  var UF_NAMES = {
    AC: 'Acre', AL: 'Alagoas', AP: 'Amapá', AM: 'Amazonas', BA: 'Bahia',
    CE: 'Ceará', DF: 'Distrito Federal', ES: 'Espírito Santo', GO: 'Goiás',
    MA: 'Maranhão', MT: 'Mato Grosso', MS: 'Mato Grosso do Sul', MG: 'Minas Gerais',
    PA: 'Pará', PB: 'Paraíba', PR: 'Paraná', PE: 'Pernambuco', PI: 'Piauí',
    RJ: 'Rio de Janeiro', RN: 'Rio Grande do Norte', RS: 'Rio Grande do Sul',
    RO: 'Rondônia', RR: 'Roraima', SC: 'Santa Catarina', SP: 'São Paulo',
    SE: 'Sergipe', TO: 'Tocantins'
  };

  function onlyDigits(v) {
    return String(v || '').replace(/\D/g, '');
  }

  function formatCep(digits) {
    if (digits.length <= 5) return digits;
    return digits.slice(0, 5) + '-' + digits.slice(5, 8);
  }

  function findField(form, names) {
    for (var i = 0; i < names.length; i++) {
      var el = form.querySelector('[name="' + names[i] + '"]');
      if (el) return el;
    }
    return null;
  }

  function setValue(el, value) {
    if (!el || value == null || value === '') return;
    el.value = value;
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function setProvince(select, uf) {
    if (!select || !uf) return;
    var name = UF_NAMES[uf] || uf;
    var options = select.options;
    var i;
    for (i = 0; i < options.length; i++) {
      var o = options[i];
      var v = (o.value || '').trim();
      var t = (o.textContent || '').trim();
      if (v === uf || v === name || t === name || t.indexOf(uf) !== -1) {
        select.value = o.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
    }
  }

  function ensureStatus(zipInput) {
    var id = zipInput.id || zipInput.name;
    var sid = 'victor-cep-status-' + id.replace(/[^\w-]/g, '_');
    var el = document.getElementById(sid);
    if (el) return el;
    el = document.createElement('p');
    el.id = sid;
    el.className = 'victor-cep-status';
    el.setAttribute('aria-live', 'polite');
    el.style.cssText = 'margin:4px 0 0;font-size:12px;color:#666;min-height:1.2em;';
    zipInput.parentNode.insertBefore(el, zipInput.nextSibling);
    return el;
  }

  function setStatus(zipInput, msg, isError) {
    var el = ensureStatus(zipInput);
    el.textContent = msg || '';
    el.style.color = isError ? '#b00020' : '#666';
  }

  function fillFromCep(zipInput, digits) {
    var form = zipInput.closest('form') || document;
    setStatus(zipInput, 'Buscando CEP…', false);

    fetch('https://viacep.com.br/ws/' + digits + '/json/')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data || data.erro) {
          setStatus(zipInput, 'CEP não encontrado. Preencha o endereço manualmente.', true);
          return;
        }

        var address1 = findField(form, ['address[address1]', 'checkout[shipping_address][address1]']);
        var address2 = findField(form, ['address[address2]', 'checkout[shipping_address][address2]']);
        var city = findField(form, ['address[city]', 'checkout[shipping_address][city]']);
        var province = findField(form, ['address[province]', 'checkout[shipping_address][province]']);
        var country = findField(form, ['address[country]', 'checkout[shipping_address][country]']);

        if (country) {
          var brOpt = null;
          for (var i = 0; i < country.options.length; i++) {
            var o = country.options[i];
            if (o.value === 'Brazil' || o.value === 'Brasil' || o.value === 'BR') {
              brOpt = o;
              break;
            }
          }
          if (brOpt && country.value !== brOpt.value) {
            country.value = brOpt.value;
            country.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        setValue(address1, data.logradouro || '');
        var bairro = data.bairro || '';
        var complemento = data.complemento || '';
        setValue(address2, [bairro, complemento].filter(Boolean).join(', '));

        setTimeout(function () {
          setProvince(province, data.uf);
          setValue(city, data.localidade || '');
          setStatus(zipInput, 'Endereço preenchido. Confira o número e o complemento.', false);
          if (address1 && !data.logradouro) {
            address1.focus();
          } else if (address1) {
            address1.focus();
            var numHint = form.querySelector('[data-victor-cep-number]');
            if (numHint) numHint.focus();
          }
        }, 80);
      })
      .catch(function () {
        setStatus(zipInput, 'Não foi possível consultar o CEP. Tente de novo.', true);
      });
  }

  function bindZip(zipInput) {
    if (zipInput.dataset.victorCepBound) return;
    zipInput.dataset.victorCepBound = '1';
    zipInput.setAttribute('inputmode', 'numeric');
    zipInput.setAttribute('autocomplete', 'postal-code');
    zipInput.setAttribute('maxlength', '9');
    zipInput.setAttribute('placeholder', zipInput.getAttribute('placeholder') || '00000-000');

    var timer = null;
    var last = '';

    function onCepChange() {
      var digits = onlyDigits(zipInput.value);
      var formatted = formatCep(digits);
      if (zipInput.value !== formatted) zipInput.value = formatted;
      if (digits.length !== 8) {
        if (digits.length > 0) setStatus(zipInput, '', false);
        return;
      }
      if (digits === last) return;
      last = digits;
      fillFromCep(zipInput, digits);
    }

    zipInput.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(onCepChange, 350);
    });
    zipInput.addEventListener('blur', onCepChange);
  }

  function scan(root) {
    var scope = root || document;
    var nodes = scope.querySelectorAll(
      'input[name="address[zip]"], input[name="checkout[shipping_address][zip]"], input[name="checkout[billing_address][zip]"], input[data-victor-cep]'
    );
    for (var i = 0; i < nodes.length; i++) bindZip(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', function () { scan(); });

  window.VictorCep = { scan: scan };
})();
